import classNames from "classnames";
import React from "react";
import {Heading, HeadingStyle, HeadingElement} from "./Heading";

import "./HeadingWithIntro.scss";

export interface IHeadingWithIntro extends React.HTMLProps<HeadingWithIntro> {
  title: any | JSX.Element;
  description: string | JSX.Element;
  headingElement?: HeadingElement;
  headingStyle?: HeadingStyle;
  onClick?: () => void;
}

/**
 * Uses `<Heading />` and adds an additional description above
 *
 * @status deprecated
 *
 * @deprecated use plain HTML tags instead
 */
export class HeadingWithIntro extends React.Component<IHeadingWithIntro, {}>{
  static HeadingStyle = HeadingStyle;
  static HeadingElement = HeadingElement;
  render(){
    return (
      <div className="heading-with-intro" onClick={this.props.onClick}>
        <div className={classNames("heading-with-intro-description", "text--caps")}>{this.props.description}</div>
        <Heading headingStyle={this.props.headingStyle} headingElement={this.props.headingElement}>{this.props.title}</Heading>
      </div>
    );
  }
}
